import { motion } from 'framer-motion';

// Utility to split text into words for staggered animation
export function StaggeredText({ children, className = '', delay = 0, stagger = 0.15 }) {
  const words = children.split(' ');

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: stagger,
        delayChildren: delay,
      },
    },
  };

  const word = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1], // Smooth easing
      },
    },
  };

  return (
    <motion.span
      className={className}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
    >
      {words.map((w, i) => (
        <motion.span
          key={i}
          variants={word}
          style={{ display: 'inline-block', marginRight: '0.25em' }}
        >
          {w}
        </motion.span>
      ))}
    </motion.span>
  );
}

// Large editorial headline with staggered reveal
export function EditorialHeadline({ children, className = '' }) {
  return (
    <StaggeredText className={`text-6xl lg:text-8xl font-bold leading-[1.1] ${className}`}>
      {children}
    </StaggeredText>
  );
}

// Subtitle with delayed reveal
export function EditorialSubtitle({ children, className = '', delay = 0.3 }) {
  return (
    <motion.p
      className={`text-xl lg:text-2xl ${className}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.p>
  );
}
